import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth/auth.guard';
import { freightGuard } from './core/guards/freight/freight.guard';
import { loginGuard } from './core/guards/login/login.guard';
import { homeResolver } from './core/resolvers/home/home.resolver';
import { metaResolver } from './core/resolvers/meta/meta.resolver';
import { featuredProductsResolver } from './core/resolvers/product-featured/product-featured.resolver';
import { productResolver } from './core/resolvers/product/product.resolver';
import { sliderSwiperResolver } from './core/resolvers/slider-swiper/slider-swiper.resolver';
import { tokenResolver } from './core/resolvers/token/token.resolver';
import { userResolver } from './core/resolvers/user/user.resolver';
import { AboutComponent } from './pages/about/about.component';
import { BudgetComponent } from './pages/budget/budget.component';
import { CartComponent } from './pages/cart/cart.component';
import { CatalogsComponent } from './pages/catalogs/catalogs.component';
import { ContactComponent } from './pages/contact/contact.component';
import { DealerComponent } from './pages/dealer/dealer.component';
import { FaqPageComponent } from './pages/faq-page/faq-page.component';
import { ForgotComponent } from './pages/forgot/forgot.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { OrderPlacedComponent } from './pages/order-placed/order-placed.component';
import { PaymentComponent } from './pages/payment/payment.component';
import { PoliciesComponent } from './pages/policies/policies.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { ProductsComponent } from './pages/products/products.component';
import { RegisterUserComponent } from './pages/register-user/register-user.component';
import { SacComponent } from './pages/sac/sac.component';
import { TermsComponent } from './pages/terms/terms.component';
import { CategoriesComponent } from './shared/components/categories/categories.component';
import { AddressCustomersComponent } from './shared/components/customer-area/address-customers/address-customers.component';
import { CustomerAreaComponent } from './shared/components/customer-area/customer-area.component';
import { DataCustomersComponent } from './shared/components/customer-area/data-customers/data-customers.component';
import { OrdersCustomersComponent } from './shared/components/customer-area/orders-customers/orders-customers.component';
import { SubcategoriesComponent } from './shared/components/subcategories/subcategories.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    resolve: {
      data: homeResolver,
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
      featuredProducts: featuredProductsResolver,
      slides: sliderSwiperResolver,
    },
  },
  {
    path: 'quem-somos',
    component: AboutComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
    },
  },
  {
    path: 'nova-senha/:token/:email',
    component: ForgotComponent,
    resolve: { meta: metaResolver },
  },
  {
    path: 'novo-cadastro/:email',
    component: RegisterUserComponent,
    canActivate: [loginGuard],
    resolve: {
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
    },
  },
  {
    path: 'fale-conosco',
    component: ContactComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
    },
  },
  {
    path: 'sac',
    component: SacComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
    },
  },
  {
    path: 'seja-um-revendedor',
    component: DealerComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
    },
  },
  {
    path: 'catalogos',
    component: CatalogsComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
    },
  },
  {
    path: 'politicas-trocas-cancelamentos',
    component: PoliciesComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
    },
  },
  {
    path: 'termos-condicoes-uso',
    component: TermsComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
    },
  },
  {
    path: 'faq',
    component: FaqPageComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
    },
  },
  {
    path: 'aviso-de-privacidade',
    component: PrivacyComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
    },
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginGuard],
    resolve: {
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
    },
  },
  {
    path: 'carrinho',
    component: CartComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
    },
  },

  {
    path: 'carrinho/:idCart',
    component: CartComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
    },
  },
  {
    path: 'orcamento/:hashBudget',
    component: BudgetComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
    },
  },
  {
    path: 'produtos/:querySearch',
    component: ProductsComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
    },
  },
  {
    path: 'produtos-em-oferta',
    component: CategoriesComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
    },
  },
  {
    path: 'pagamento',
    component: PaymentComponent,
    canActivate: [freightGuard],
    resolve: {
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
    },
  },
  {
    path: 'pagamento/:hashBudget',
    component: PaymentComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
    },
  },
  {
    path: 'area-do-cliente',
    component: CustomerAreaComponent,
    canActivate: [authGuard],
    resolve: {
      token: tokenResolver,
      user: userResolver,
    },

    children: [
      {
        path: 'meus-pedidos',
        component: OrdersCustomersComponent,
        resolve: { meta: metaResolver },
      },
      {
        path: 'meus-dados',
        component: DataCustomersComponent,
        resolve: { meta: metaResolver },
      },
      {
        path: 'meu-endereco',
        component: AddressCustomersComponent,
        resolve: { meta: metaResolver },
      },
    ],
  },
  {
    path: 'coberturas-em-policarbonato',
    component: CategoriesComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
    },

    children: [
      {
        path: ':subcategory',
        component: SubcategoriesComponent,
        children: [
          {
            path: ':sku/:name',
            component: ProductsComponent,
            resolve: { product: productResolver },
          },
        ],
      },
    ],
  },

  {
    path: 'kits',
    component: CategoriesComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
    },

    children: [
      {
        path: ':subcategory',
        component: SubcategoriesComponent,

        children: [
          {
            path: ':sku/:name',
            component: ProductsComponent,
            resolve: { product: productResolver },
          },
        ],
      },
    ],
  },
  {
    path: 'toldos',
    component: CategoriesComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
    },

    children: [
      {
        path: ':subcategory',
        component: SubcategoriesComponent,

        children: [
          {
            path: ':sku/:name',
            component: ProductsComponent,
            resolve: { product: productResolver },
          },
        ],
      },
    ],
  },
  {
    path: 'comunicacao-visual',
    component: CategoriesComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
    },

    children: [
      {
        path: ':subcategory',
        component: SubcategoriesComponent,

        children: [
          {
            path: ':sku/:name',
            component: ProductsComponent,
            resolve: { product: productResolver },
          },
        ],
      },
    ],
  },
  {
    path: 'perfis-em-aluminio',
    component: CategoriesComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
    },

    children: [
      {
        path: ':subcategory',
        component: SubcategoriesComponent,

        children: [
          {
            path: ':sku/:name',
            component: ProductsComponent,
            resolve: { product: productResolver },
          },
        ],
      },
    ],
  },
  {
    path: 'acessorios-de-instalacao',
    component: CategoriesComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
    },

    children: [
      {
        path: ':subcategory',
        component: SubcategoriesComponent,

        children: [
          {
            path: ':sku/:name',
            component: ProductsComponent,
            resolve: { product: productResolver },
          },
        ],
      },
    ],
  },
  {
    path: 'persianas',
    component: CategoriesComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
    },

    children: [
      {
        path: ':subcategory',
        component: SubcategoriesComponent,

        children: [
          {
            path: ':sku/:name',
            component: ProductsComponent,
            resolve: { product: productResolver },
          },
        ],
      },
    ],
  },
  {
    path: 'decoracao',
    component: CategoriesComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
    },

    children: [
      {
        path: ':subcategory',
        component: SubcategoriesComponent,
        children: [
          {
            path: ':sku/:name',
            component: ProductsComponent,
            resolve: { product: productResolver },
          },
        ],
      },
    ],
  },
  {
    path: 'black-friday',
    component: CategoriesComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
    },
  },
  {
    path: 'confirmacao',
    component: OrderPlacedComponent,
    resolve: { meta: metaResolver },
  },
  {
    path: 'pagina-nao-encontrada',
    component: NotFoundComponent,
    resolve: {
      token: tokenResolver,
      user: userResolver,
      meta: metaResolver,
    },
  },
  {
    path: 'produtos',
    redirectTo: 'coberturas-em-policarbonato/policarbonato-alveolar',
    pathMatch: 'full',
  },
  { path: '**', pathMatch: 'full', component: NotFoundComponent },
];
